(function ($, undefined) {
    $.fn.center = function (options) {

        var options = options || {};
        if (options.paddingWidth == undefined) {
            options.paddingWidth = 150;
        }

        function centerToWindow() {
            var t = $(this);
            var currentZIndex = parseInt(t.css("zIndex"));
            t.css({
                position: options.absolute ? 'absolute' : 'fixed',
                left: '50%',
                top: '50%',
                zIndex: currentZIndex + 1
            }).css({
                marginLeft: '-' + (t.outerWidth() / 2) + 'px',
                marginTop: '-' + (t.outerHeight() / 2) + 'px'
            });

            if (options.absolute) {
                t.css({
                    marginTop: parseInt(t.css('marginTop'), 10) + jQuery(window).scrollTop(),
                    marginLeft: parseInt(t.css('marginLeft'), 10) + jQuery(window).scrollLeft()
                });
            }
        }

        function sizeToWindow() {
            var t = $(this);            

            var newWidth = $(window).width() - options.paddingWidth;
            var paddedWindowHeight = $(window).height() - options.paddingWidth;
            var newHeight = paddedWindowHeight;

            if (options.maxWidth && newWidth > options.maxWidth) {
                newWidth = options.maxWidth;
            }
            else if (options.minWidth && newWidth < options.minWidth) {
                newWidth = options.minWidth;
            }

            t.css('width', newWidth);

            if (options.autoHeight) {
                if (t.attr("data-auto-height") == null) {
                    t.css('height', "auto");
                    newHeight = t.outerHeight();
                    t.attr("data-auto-height", "1");
                }
                return;
            }
            else {
                if (options.maxHeight && newHeight > options.maxHeight) {
                    newHeight = options.maxHeight;
                }

                if (options.minHeight && newHeight < options.minHeight) {
                    newHeight = options.minHeight;
                }
            }

            if (newHeight > paddedWindowHeight) {
                newHeight = paddedWindowHeight;
            }            
        }

        function bindEvents() {
            var t = $(this);
            if (t[0]._centerEventsBound) {
                return;
            }
            $(window).bind('resize', function () {
                if (options.sizeToWindow) {
                    t.each(sizeToWindow);
                }
                t.each(centerToWindow);

            });
            $(window).bind('scroll', function () {
                t.each(centerToWindow);
            });
            t[0]._centerEventsBound = true;
        }

        var elem = this;


        // Size to window
        if (options.sizeToWindow) {
            elem.each(sizeToWindow);
        }

        // Center to window
        elem.each(centerToWindow);

        // Bind events    
        elem.each(bindEvents);


        return elem;
    };
})(jQuery);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.JQuery.Center-test.js